
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import documentExecutionSchedulationsTableDescriptor from './DocumentExecutionSchedulationsTableDescriptor.json'

    export default defineComponent({
        name: 'document-execution-help-dialog',
        components: { Dialog },
        props: { visible: { type: Boolean }, propUrl: { type: String } },
        emits: ['close'],
        data() {
            return {
                documentExecutionSchedulationsTableDescriptor,
                url: '' as string
            }
        },
        watch: {
            propUrl() {
                this.loadUrl()
            }
        },
        created() {
            this.loadUrl()
        },
        methods: {
            loadUrl() {
                this.url = this.propUrl as any
            },
            closeDialog() {
                this.$emit('close')
            }
        }
    })
